import React, { useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

/**
 * withVisibilitySensor - Wraps a component in a VisibilitySensor, which will call a method that is passed in when the component is in the viewport for the first time
 * The component only needs to be partially in the viewport to trigger.
 * The method being called is usually a gaTrackEvent or recordAssignment
 * @param BaseComponent {JSX.Element} - The component being wrapped
 * @param onFirstScrollToComponent {function} - The function that gets called when the component is scrolled into view.
 * @returns {(JSX.Element)}
 */
export const withVisibilitySensor = BaseComponent => ({
    onFirstScrollToComponent,
    ...props
}) => {
    const [isActiveVisibilitySensor, setIsActiveVisibilitySensor] = useState(
        true
    );

    const handleChangeVisibilitySensor = isVisible => {
        if (isVisible) {
            setIsActiveVisibilitySensor(false);
            // eslint-disable-next-line no-unused-expressions
            onFirstScrollToComponent && onFirstScrollToComponent();
        }
    };

    return (
        <VisibilitySensor
            active={isActiveVisibilitySensor}
            onChange={handleChangeVisibilitySensor}
            partialVisibility
        >
            <BaseComponent {...props} />
        </VisibilitySensor>
    );
};

export default withVisibilitySensor;
